var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "280px",
    height: "188px",
    viewBox: "0 0 280 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "29.3690975%",
    x2: "99.999575%",
    y2: "33.4143726%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.011,10 L108.925,13.415 L125.635,23.063 L125.634582,44.454934 C127.44744,43.9090399 129.264206,43.442439 131.0849,43.0557 C138.4969,41.4967 145.6849,41.2057 152.6479,42.1837 C159.6319,43.1727 166.1139,45.3927 172.0899,48.8437 C173.1009,49.4277 174.0279,50.0227 174.9149,50.6227 C179.2809,53.5737 182.1889,56.7267 183.5949,60.0877 C184.2099,61.5347 184.5299,62.9987 184.5759,64.4777 L184.575,93.586 L236.2766,86.9402 L248.8746,94.2142 L258.9006,100.0022 L258.9006,133.124496 C258.9006,134.554792 258.136898,135.876245 256.897609,136.590323 L224.77472,155.099525 L224.8366,163.8602 L210.9536,171.8752 L203.3696,167.4962 L193.0866,173.4342 L175.9896,163.5642 L176.054525,153.13043 L156.105187,140.327771 C154.958795,139.592064 154.2656,138.323535 154.2656,136.961376 L154.265752,126.703255 C151.209721,127.808427 148.131771,128.694909 145.0319,129.3627 C137.5119,130.9827 130.2059,131.3297 123.1149,130.4017 C116.0669,129.4737 109.5539,127.2847 103.5759,123.8347 C99.0779,121.2177 95.8249,118.4217 93.8069,115.4467 C93.1529,114.4827 92.6249,113.5007 92.2319,112.4977 C91.6709,111.0677 91.3959,109.6227 91.3729,108.1617 L91.372,87.034 L77.689,94.935 L70.104,90.556 L59.821,96.494 L42.725,86.622 L42.7633313,74.9817189 L21,62.205 L21,26.773 L34.883,18.758 L103.011,10 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.1%",
    y: "-14.7%",
    width: "120.2%",
    height: "129.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-13.7%",
    y: "-19.9%",
    width: "127.3%",
    height: "139.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "20.1295734%",
    x2: "99.999575%",
    y2: "25.9865199%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-6",
    points: "82.011 0 13.883 8.758 0 16.773 0 52.205 21.7633313 64.9817189 21.725 76.622 38.821 86.494 49.104 80.556 56.689 84.935 70.571 76.919 70.5435185 71.5524758 104.635 48.496 104.635 13.063 87.925 3.415"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.1%",
    y: "-9.8%",
    width: "116.2%",
    height: "119.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "9.87920071%",
    x2: "99.999575%",
    y2: "17.7460242%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162.5949,50.0877 C161.1889,46.7267 158.2809,43.5737 153.9149,40.6227 C153.0279,40.0227 152.1009,39.4277 151.0899,38.8437 C145.1139,35.3927 138.6319,33.1727 131.6479,32.1837 C124.6849,31.2057 117.4969,31.4967 110.0849,33.0557 C103.3339,34.4897 96.6369,37.0217 89.9929,40.6227 C89.3629,40.9647 88.7329,41.3027 88.1039,41.6647 C80.8619,45.8197 75.8389,50.0687 73.0319,54.4107 C71.3279,57.0457 70.4509,59.6347 70.3729,62.1787 L70.3729,62.7287 L70.3729,97.6117 L70.3729,98.1617 C70.3959,99.6227 70.6709,101.0677 71.2319,102.4977 C71.6249,103.5007 72.1529,104.4827 72.8069,105.4467 C74.8249,108.4217 78.0779,111.2177 82.5759,113.8347 C88.5539,117.2847 95.0669,119.4737 102.1149,120.4017 C109.2059,121.3297 116.5119,120.9827 124.0319,119.3627 C131.5519,117.7427 138.9429,114.8357 146.2049,110.6417 C149.2039,108.9207 151.7899,107.1887 154.0109,105.4467 C157.1519,102.9817 159.5349,100.4967 161.1159,97.9887 C162.7369,95.4207 163.5459,92.8977 163.5759,90.4187 L163.5759,89.9107 L163.5759,54.9847 L163.5759,54.4777 C163.5299,52.9987 163.2099,51.5347 162.5949,50.0877",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.1%",
    y: "-9.5%",
    width: "118.2%",
    height: "119.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M237.9006,90.0022 L227.8746,84.2142 L215.2766,76.9402 L147.1476,85.6982 L133.2656,93.7132 L133.2656,126.961376 C133.2656,128.323535 133.958795,129.592064 135.105187,130.327771 L155.054525,143.13043 L155.054525,143.13043 L154.9896,153.5642 L172.0866,163.4342 L182.3696,157.4962 L189.9536,161.8752 L203.8366,153.8602 L203.77472,145.099525 L235.897609,126.590323 C237.136898,125.876245 237.9006,124.554792 237.9006,123.124496 L237.9006,90.0022 L237.9006,90.0022 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.1%",
    y: "-9.8%",
    width: "116.2%",
    height: "119.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.011,7.10542736e-14 L108.925,3.415 L125.635,13.063 L83.987,37.108 L91.571,41.486 L77.689,49.502 L70.104,45.123 L59.821,51.061 L42.725,41.189 L53.008,35.253 L21,16.773 L34.883,8.758 L103.011,7.10542736e-14 Z M89.901,13.804 L53.008,18.628 L52.494,18.925 L67.277,27.46 L90.415,14.101 L89.901,13.804 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-2.9%",
    width: "102.9%",
    height: "105.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.0848,33.0551 C138.4968,31.4971 145.6848,31.2061 152.6478,32.1831 C159.6318,33.1731 166.1138,35.3931 172.0898,38.8441 C178.0678,42.2951 181.9028,46.0431 183.5948,50.0881 C185.3088,54.1201 184.8168,58.2761 182.1178,62.5561 C179.4168,66.8361 174.4478,71.0531 167.2048,75.2091 C159.9428,79.4031 152.5518,82.3101 145.0318,83.9291 C137.5128,85.5501 130.2058,85.8971 123.1148,84.9691 C116.0668,84.0411 109.5538,81.8521 103.5768,78.4011 C97.6208,74.9381 93.8388,71.1591 92.2318,67.0651 C90.6258,62.9701 91.2248,58.7521 94.0318,54.4111 C96.8388,50.0691 101.8618,45.8201 109.1038,41.6641 C116.3668,37.4961 123.6938,34.6261 131.0848,33.0551 Z M157.6938,47.1561 C154.6088,45.3751 150.5268,44.8241 145.4498,45.5051 C140.3718,46.1851 134.4268,48.4671 127.6138,52.3511 C122.9858,54.9981 119.6338,57.4411 117.5558,59.6801 C115.4988,61.9061 114.5558,63.8861 114.7268,65.6171 C114.9198,67.3611 116.0448,68.8271 118.1018,70.0141 C121.1868,71.7961 125.3218,72.3281 130.5068,71.6101 C135.7338,70.8931 141.7968,68.5301 148.6958,64.5221 C153.2158,61.9121 156.4608,59.5191 158.4328,57.3421 C160.4038,55.1651 161.2828,53.2231 161.0678,51.5161 C160.8748,49.7971 159.7498,48.3431 157.6938,47.1561 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.6%",
    y: "-2.8%",
    width: "103.2%",
    height: "105.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-20",
    points: "154.2656 76.9402 258.9003 76.9402 258.9003 163.4337 154.2656 163.4337"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-22",
    points: "154.2657 76.9406 258.9003 76.9406 258.9003 128.0006 154.2657 128.0006"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-24"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.2767,76.9406 L248.8747,84.2146 L258.9007,90.0026 L217.2517,114.0476 L224.8357,118.4266 L210.9537,126.4426 L203.3697,122.0636 L193.0857,128.0006 L175.9897,118.1306 L186.2727,112.1936 L154.2657,93.7136 L168.1487,85.6986 L236.2767,76.9406 Z M223.1657,90.7446 L186.2727,95.5686 L185.7577,95.8656 L200.5417,104.4006 L223.6787,91.0416 L223.1657,90.7446 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-2.9%",
    width: "102.9%",
    height: "105.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-26"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-27",
    points: "175.9896 118.1303 193.0856 118.1303 193.0856 163.4337 175.9896 163.4337"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-29",
    points: "193.0236 122.0633 203.3696 122.0633 203.3696 163.4337 193.0236 163.4337"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 404,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "103.011 0 34.883 8.758 21 16.773 53.008 35.253 42.725 41.189 59.821 51.061 70.104 45.123 77.689 49.502 91.571 41.486 83.987 37.108 125.635 13.063 108.925 3.415"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "52.494 18.925 53.008 18.628 89.901 13.804 90.415 14.101 67.277 27.46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glow",
    filter: "url(#filter-3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(21.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-2"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    fillRule: "evenodd",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fillOpacity: 0.1,
    fill: "#FFFFFF",
    points: "42.7253 41.1897 42.7253 76.6227 59.8213 86.4937 59.8213 51.0607"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fillOpacity: 0.1,
    fill: "#000000",
    points: "59.8215 51.0603 70.1055 45.1233 70.1055 80.5563 59.8215 86.4933"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fillOpacity: 0.1,
    fill: "#FFFFFF",
    points: "70.1052 45.1233 77.6892 49.5013 77.6892 84.9353 70.1052 80.5563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fillOpacity: 0.1,
    fill: "#000000",
    points: "91.572 76.9197 91.572 41.4867 77.689 49.5017 77.689 84.9347"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-13)",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-16)",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    mask: "url(#mask-23)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-24)",
    fillRule: "evenodd",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-26)",
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fillOpacity: 0.1,
    fill: "#FFFFFF",
    points: "193.0236 128.0003 193.0856 163.4343 175.9896 153.5633 175.9896 118.1303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fillOpacity: 0.1,
    fill: "#000000",
    points: "193.0236 128.0003 203.3696 122.0633 203.3696 157.4963 193.0856 163.4343"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fillOpacity: 0.01,
    fill: "#FFFFFF",
    points: "203.3693 122.0637 210.9533 126.4427 210.9533 161.8757 203.3693 157.4967"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fillOpacity: 0.1,
    fill: "#000000",
    points: "210.9533 126.4426 224.8363 118.4266 224.8363 153.8606 210.9533 161.8756"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.e24cd29aed22d36a5802bb3c353280c7.svg";
export { ForwardRef as ReactComponent };